import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ContactComponent } from '../contact/contact.component';
import { fadeIn } from '../../../animation';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [TranslateModule, ContactComponent, ContactComponent, RouterLink, RouterLinkActive],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  animations: [fadeIn(1500, 1500, false)]
})
export class HomeComponent {

  changeImg: boolean=false;
  constructor(){

    this.changeImg=false;

  }

}
